module.exports = __webpack_public_path__ + "static/media/9.0c00bbb7.jpg";